export { default as SentToSwitch } from './SentToSwitch';
